import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  EmmaActive, RadarShot, MatchShot, MiniFiche, WhatsAppShot,
  EmailStaging, PartnerShot, SignalShot, RecapShot, TimelineShot, CTAJoin,
} from "./AgentFilm";

// Manoir du film (meme maison que le plan 'annonce' et la remise des cles)
const MANOR = "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/bd2e96549e012a075d1cc342c1d0407eaaf3654c7d8fb3b6894e12a1216ea212.jpeg";

const CARDS = {
  emma: () => <EmmaActive />,
  radar: () => <RadarShot />,
  match: () => <MatchShot house={MANOR} title="Manoir de charme" score={94} />,
  fiche: () => <MiniFiche />,
  whatsapp: () => <WhatsAppShot />,
  staging: () => <EmailStaging />,
  partner: () => <PartnerShot />,
  cta: () => <CTAJoin />,
  signal: () => <SignalShot />,
  recap: () => <RecapShot />,
  timeline: () => <TimelineShot />,
};

// Page dediee a la capture (Playwright) des encarts animes sur fond transparent.
export default function FilmCardCapture() {
  const q = new URLSearchParams(useLocation().search);
  const name = q.get("c") || "match";
  const w = parseInt(q.get("w") || "470", 10);
  const Card = CARDS[name] || CARDS.match;

  useEffect(() => {
    const prevH = document.documentElement.style.background;
    const prevB = document.body.style.background;
    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";
    return () => {
      document.documentElement.style.background = prevH;
      document.body.style.background = prevB;
    };
  }, []);

  return (
    <div style={{ background: "transparent", minHeight: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center", paddingTop: 18, paddingLeft: 16, paddingRight: 16 }} data-testid="filmcard-capture">
      <div style={{ width: w }} data-card-root="1">
        <Card />
      </div>
    </div>
  );
}
